<template>
  <div class="confirm-order-modular">
    <!-- <HeaderUserInfo></HeaderUserInfo> -->
    <!-- <ShareRight></ShareRight> -->
    <div class="confirm-order-show-info-modualr">
      <div class="confirm-order-header-modular">
        <div class="logo-modular" @click="toHome()">
          <img class="logo-img" :src="logo" alt="" />
        </div>
        <div class="steps-modular">
          <el-steps :active="active" finish-status="success" align-center>
            <el-step :title="pageTextArr[0]"></el-step>
            <el-step :title="pageTextArr[1]"></el-step>
            <el-step :title="pageTextArr[2]"></el-step>
          </el-steps>
        </div>
      </div>
      <div class="receiving-information-modular" v-if="method_type != 2"
        style="display: flex;justify-content: space-between;">
        <div>
          <div class="receiving-information-title">
            <div>{{ pageTextArr[3] }}</div>
          </div>
          <div class="receipt-info-modular">
            <div class="receipt-item" v-for="(item, index) in showReceiptInfoList" :key="index" v-if="index < showIndex"
              @click="selectRecipt(item.id, index, item.country_id)">
              <img v-if="currAddressId == item.id" class="radio-icon" src="../assets/order/radio-icon-1.png" alt="" />
              <img v-else class="radio-icon" src="../assets/order/radio-icon-0.png" alt="" />
              <div class="receipt-name">{{ item.recivername }}</div>
              <div class="receipt-address">
                {{ item.province + item.city + item.area + item.address }}
              </div>
              <div class="receipt-mobile">{{ item.mobile }}</div>
            </div>
          </div>
          <div class="receipt-info-modular" v-if="receiptInfoList.length > 3">
            <div class="selectMoreAddress" @click="showMoreAddress" v-if="isDown">
              <span>{{
                pageTextArr[41]
              }}</span>
              <img src="../assets/order/down.png" alt="" srcset="">
            </div>
            <div class="selectMoreAddress" @click="noshowMoreAddress" v-else>
              <span>{{
                pageTextArr[42]
              }}</span>
              <img src="../assets/order/up.png" alt="" srcset="">
            </div>
          </div>
        </div>
        <div class="add-address-btn" @click="addNewAddress()">{{ pageTextArr[5] }}</div>
      </div>
      <div class="receiving-information-modular" v-if="method_type == 2">
        <div class="receiving-information-title">
          <div>{{ pageTextArr[6] }}</div>
        </div>
        <div class="receipt-info-modular">
          <div class="receipt-item">
            <!-- <div class="receipt-item" 
            @click="selectRecipt(item.id, index, item.country_id)"> -->
            <!-- <img v-if="currAddressId == item.id" class="radio-icon" src="../assets/order/radio-icon-1.png" alt="" />
            <img v-else class="radio-icon" src="../assets/order/radio-icon-0.png" alt="" /> -->
            <!-- <div class="receipt-name">{{ item.recivername }}</div>-->
            <div class="receipt-name">{{ selfPromotionList.contact_name }}</div>
            <div class="receipt-address">
              <!-- {{ item.province + item.city + item.area + item.address }} -->
              {{ selfPromotionList.address }}
            </div>
            <div class="receipt-mobile">
              {{ selfPromotionList.contact_mobile }}
            </div>
          </div>
        </div>
      </div>
      <div class="pay-modular">
        <div class="pay-title">{{ pageTextArr[7] }}</div>
        <div class="pay-mode-modular">
          <div :class="
            CurrpayModeType == item.type
              ? 'pay-mode-item pay-mode-item-active'
              : 'pay-mode-item'
          " v-for="(item, index) in payModeList" :key="index" @click="selectPay(index, item.type)"
            v-if="item.type != 2">
            <!-- 支付宝 - 1 -->
            <img v-if="item.type == 1" class="pay-mode-img" src="../assets/order/pay-zfb-icon.png" alt="" />
            <!-- 微信 - 2 -->
            <!-- <img v-if="item.type==2" class="pay-mode-img" :src="item.image" alt=""> -->
            <!-- PayPal - 3 -->
            <img v-if="item.type == 3" class="pay-mode-img" src="../assets/order/pay-pal-icon.png" alt="" />
            <!-- TT-支付文字 -->
            <!-- <span v-else>{{ item.title }}</span> -->
            <img v-if="CurrpayModeType == item.type" class="selected-icon" src="../assets/order/selected-icon.png"
              alt="" />
          </div>
        </div>
      </div>
      <div class="pay-modular" v-if="tranportModeList.length>0">
        <div class="pay-title">
          {{ pageTextArr[8] }}
          <img class="doubt-icon" src="../assets/productDetail/doubt-icon.png" alt=""
            @click="transportTypeConsultation()" />
          <span class="doubt-text">{{ pageTextArr[9] }}</span>
        </div>
        <div class="pay-mode-modular">
          <!-- <el-cascader
            v-model="value"
            :options="tranportModeList"
            @change="handleChange"confirm-product-information-table
          ></el-cascader> -->
          <div :class="
            CurrtransportId == item.id
              ? 'pay-mode-item pay-mode-item-active'
              : 'pay-mode-item'
          " v-for="(item, index) in tranportModeList" :key="index" @click="selectTransport(item.id, item.method_type)">
            <img v-if="item.imgUrl != ''" class="pay-mode-img" :src="item.imgUrl" alt="" />
            <span>{{ currLanguage == 3 ? item.eng_name : item.name }}</span>
            <img v-if="CurrtransportId == item.id" class="selected-icon" src="../assets/order/selected-icon.png" alt="" />
          </div>
        </div>
      </div>
      <!-- <div class="pay-modular">
        <div class="pay-title">
          计算方式
        </div>
        <div class="pay-mode-modular">
          <div
            :class="
              freight_type == item.id
                ? 'pay-mode-item pay-mode-item-active'
                : 'pay-mode-item'
            "
            v-for="(item, index) in tranportModeList1"
            :key="index"
            @click="selectTransport1(item.id)"
          >
            <img
              v-if="item.imgUrl != ''"
              class="pay-mode-img"
              :src="item.imgUrl"
              alt=""
            />
            <span>{{ item.name }}</span>
            <img
              v-if="freight_type == item.id"
              class="selected-icon"
              src="../assets/order/selected-icon.png"
              alt=""
            />
          </div>
        </div>
      </div> -->
      <div class="confirm-product-information-modular">
        <div class="title">{{ pageTextArr[10] }}</div>
        <div class="confirm-product-information-table">
          <div class="confirm-product-information-thead">
            <div class="product-info">{{ pageTextArr[11] }}</div>
            <div class="product-unit-price">{{ pageTextArr[12] }}</div>
            <div class="product-number">{{ pageTextArr[13] }}</div>
            <div class="product-total">{{ pageTextArr[14] }}</div>
          </div>
          <div class="confirm-product-information-tbody">
            <div v-for="(item, index) in confirmProductInformation" :key="index">
              <!--组合商品  -->
              <div class="confirm-product-information-item" v-if="item.type == 2"
                v-for="(item2, index2) in item.product_data" :key="index2" style="margin-top: 10px">
                <div class="product-info">
                  <img class="product-info-img" :src="item2.cover" alt="" @click="toProductDetail(item2.id)" />
                  <div class="tbody-item-info-voltage">
                    <div class="produce-info-troduce">
                      {{ currLanguage == 3 ? item2.eng_title : item2.title }}
                    </div>
                    <div class="product-voltage">
                      {{
                        currLanguage == 3
                        ? item2.eng_specifications
                        : item2.specifications
                      }}
                    </div>
                  </div>
                </div>
                <div class="product-unit-price">
                  <div v-if="index2 == 0">
                    <div class="originalPrice">
                      {{ exchangeRateSymbol + item.total_price }}
                    </div>
                    <div class="presentPrice">
                      {{ exchangeRateSymbol + item.total_discount_price }}
                    </div>
                  </div>
                </div>
                <div class="product-number">
                  <div v-if="index2 == 0">
                    {{ item2.num }}
                  </div>
                </div>
                <div class="product-total">
                  <div v-if="index2 == 0">
                    {{ exchangeRateSymbol + item.amountMoney }}
                  </div>
                </div>
              </div>
              <!-- 单个商品 v-if="item.product_data.length == 1"-->
              <div v-if="item.type == 1" class="confirm-product-information-item"
                v-for="(item3, index3) in item.product_data" :key="index3">
                <div class="product-info">
                  <img class="product-info-img" :src="item3.cover" alt="" />
                  <div class="tbody-item-info-voltage">
                    <div class="produce-info-troduce">
                      {{ currLanguage == 3 ? item3.eng_title : item3.title }}
                    </div>
                    <div class="product-voltage">
                      {{
                        currLanguage == 3
                        ? item3.eng_specifications
                        : item3.specifications
                      }}
                    </div>
                  </div>
                </div>
                <div class="product-unit-price">
                  <div class="originalPrice" v-if="item3.has_discount == 1">
                    {{ exchangeRateSymbol + item3.price }}
                  </div>
                  <div class="presentPrice" v-else-if="item3.has_wholesale_price == 1">
                    {{ exchangeRateSymbol + item3.discount_price }}
                  </div>
                  <div class="presentPrice">
                    {{
                      exchangeRateSymbol +
                      (item3.has_discount == 1
                        ? item3.discount_price
                        : item3.price)
                    }}
                  </div>
                </div>
                <div class="product-number">
                  {{ item3.num }}
                </div>
                <div class="product-total">
                  {{ exchangeRateSymbol + item.amountMoney }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="settlement-information-modular">
        <div class="title">{{ pageTextArr[15] }}</div>
        <div class="use-coupon-modular">
          <div class="use-coupon-header">
            <img class="togger-icon" v-if="isShowCoupon" @click="toggerShowCoupon()" src="../assets/order/show-icon.png"
              alt="" />
            <img class="togger-icon" v-else @click="toggerShowCoupon()" src="../assets/order/hide-icon.png" alt="" />
            <span class="use-coupon-title">{{ pageTextArr[16] }}</span>
          </div>
          <div class="use-coupon-body" v-if="isShowCoupon">
            <el-tabs type="border-card" class="use-coupon-tabs" @tab-click="selectTabs">
              <el-tab-pane :label="currLanguage == 3 ? item0.eng_title : item0.title"
                v-for="(item0, index0) in availablTabsList" :key="index0">
                <div class="tabs-coupon-item-info">
                  <div :class="
                    index0 == 0
                      ? 'tabs-coupon-item'
                      : 'tabs-coupon-item no-tabs-coupon-item'
                  " v-for="(item, index) in showCouponList" @click="
  selectCoupon(
    index,
    item.cate,
    item.discount,
    item.cash,
    index0
  )
">
                    <el-row :gutter="20" style="display: flex; align-items: center">
                      <el-col :span="5" :xs="12">
                        <div class="tabs-coupon-item-checkbox">
                          <span v-if="index0 == 0">
                            <img class="checkBox-icon" v-if="item.flag" src="../assets/order/checkBox-icon-1.png"
                              alt="" />
                            <img class="checkBox-icon" v-else src="../assets/order/checkBox-icon-0.png" alt="" />
                          </span>
                          <span class="tabs-coupon-item-symbol" v-if="item.cate == 2">{{ exchangeRateSymbol }}</span>
                          <span class="tabs-coupon-item-money" v-if="item.cate == 1">{{ item.discount }}%</span>
                          <span class="tabs-coupon-item-money" v-if="item.cate == 2">
                            {{ item.cash }}</span>
                        </div>
                      </el-col>
                      <el-col :span="5" :xs="12">
                        <!-- 	1折扣券2现金券 -->
                        <div class="tabs-coupon-item-rule" v-if="item.cate == 1">
                          {{
                            pageTextArr[27] +
                            exchangeRateSymbol +
                            item.low_cash +
                            pageTextArr[28] +
                            parseFloat(item.discount) +
                            "%"
                          }}
                        </div>
                        <div class="tabs-coupon-item-rule" v-if="item.cate == 2">
                          {{
                            pageTextArr[27] +
                            exchangeRateSymbol +
                            item.low_cash +
                            pageTextArr[28] +
                            item.cash
                          }}
                        </div>
                      </el-col>
                      <el-col :span="5" :xs="24">
                        <div class="tabs-coupon-item-limit" v-if="item.apply_cate == 1">
                          {{ pageTextArr[29] }}
                        </div>
                        <div class="tabs-coupon-item-limit" v-if="item.apply_cate == 3">
                          {{ currLanguage == 1 ? item.msg2 : item.eng_msg2 }}
                        </div>
                        <div class="tabs-coupon-item-limit" v-else>
                          {{ currLanguage == 1 ? item.msg1 : item.eng_msg1 }}
                        </div>
                      </el-col>
                      <el-col :span="10" :xs="24" style="padding-right: 40px">
                        <div class="tabs-coupon-item-expirationDate" style="text-align: right">
                          {{ pageTextArr[30] }}{{ item.end_time }}
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </el-tab-pane>
              <!-- <el-tab-pane :label="availablTabsList[1].title">
                                            <div class="tabs-coupon-item-info">
                                              <div class="tabs-coupon-item no-tabs-coupon-item" v-for="(item, index) in availablCouponList.list">
                                                <el-row :gutter="20" style="display: flex;align-items: center;">
                                                  <el-col :span="3" :xs="12">
                                                    <div class="tabs-coupon-item-checkbox">
                                                      <span class="tabs-coupon-item-symbol">$</span>
                                                      <span class="tabs-coupon-item-money">
                                                        {{ item.money }}
                                                      </span>
                                                    </div>
                                                  </el-col>
                                                  <el-col :span="7" :xs="12">
                                                    <div class="tabs-coupon-item-rule">
                                                      {{ item.rule }}
                                                    </div>
                                                  </el-col>
                                                  <el-col :span="8" :xs="24">
                                                    <div class="tabs-coupon-item-limit">
                                                      {{ item.limit }}
                                                    </div>
                                                  </el-col>
                                                  <el-col :span="6" :xs="24">
                                                    <div class="tabs-coupon-item-expirationDate">
                                                      有效期至{{ item.expirationDate }}
                                                    </div>
                                                  </el-col>
                                                </el-row>
                                              </div>
                                            </div>
                                          </el-tab-pane> -->
            </el-tabs>
          </div>
          <div class="use-coupon-footer">
            <div class="product-total">
              <div class="product-num">
                {{ confirmProductInformation.length }}
              </div>
              <div class="product-num-title product-item-title">
                {{ pageTextArr[19] }}
                {{ pageTextArr[31] }}：
              </div>
              <div class="product-sum-money product-item-money">
                {{ exchangeRateSymbol + productTotalPrice }}
              </div>
            </div>
            <div class="product-freight">
              <div class="product-freight-title product-item-title">
                {{ pageTextArr[21] }}
                <img class="doubt-icon" src="../assets/productDetail/doubt-icon.png" alt=""
                  @click="transportTypeConsultation()" />
                <span class="doubt-text">{{ pageTextArr[9] }}</span>
                ：
              </div>
              <div class="product-freight-money product-item-money">
                {{ exchangeRateSymbol + availablCouponList.freight }}
              </div>
            </div>
            <div class="product-freight">
              <div class="product-freight-title product-item-title">
                {{ pageTextArr[20] }}：
              </div>
              <div class="product-freight-money product-item-money">
                {{ exchangeRateSymbol + availablCouponList.taxation }}
              </div>
            </div>
            <div class="product-freight">
              <div class="product-freight-title product-item-title">
                {{ pageTextArr[23] }}：
              </div>
              <div class="product-freight-money product-item-money">
                -{{
                  exchangeRateSymbol + availablCouponList.full_discount_price
                }}
              </div>
            </div>
            <div class="product-coupon-money" v-if="showCouponMoney">
              <div class="product-coupon-title product-item-title">
                {{ pageTextArr[22] + ":" }}
              </div>
              <div class="product-coupon-money product-item-money">
                -{{ exchangeRateSymbol + availablCouponList.couponMoney }}
              </div>
            </div>
          </div>
        </div>
        <div class="settlement-total-info-modualr">
          <div class="money-sum">
            <span class="left-title">{{ pageTextArr[24] }}：</span>
            <span class="money-sum-title">{{
              exchangeRateSymbol + availablCouponList.sum
            }}</span>
          </div>
          <div class="money-address">{{ availablCouponList.address }}</div>
          <div class="money-pay-mode">
            <span class="left-title">{{ pageTextArr[25] }}：</span>
            <span class="money-pay-mode-title">
              {{ availablCouponList.payMod }}
            </span>
          </div>
          <el-button class="submit-order-btn" @click="submitOrder()">{{
            pageTextArr[26]
          }}</el-button>
        </div>
      </div>
    </div>

    <!-- 运费疑问弹窗 发送咨询内容 -->
    <!-- <el-dialog
      title="运费疑问咨询"
      :visible.sync="freightQuestionVisible"
      width="30%"
    >
      <el-input
        type="textarea"
        :rows="4"
        placeholder="请输入咨询内容"
        v-model="questionContent"
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="freightQuestionVisible = false">取 消</el-button>
        <el-button type="primary" @click="freightQuestionVisible = false"
          >发 送</el-button
        >
      </span>
    </el-dialog> -->
    <!-- 运输方式弹窗 发送咨询内容 -->
    <el-dialog :title="pageTextArr[32]" :visible.sync="transportQuestionVisible">
      <div class="question-content-modular">
        <div class="question-content" v-for="(item, index) in chatList" :key="index">
          <ul>
            <li v-if="item.flag == 2" class="item-content left-item">
              <div class="time">{{ item.create_time }}</div>
              <div class="item-content-left">
                <img src="../assets/public/portrait-icon.png" alt="" />
                <div class="item-message">{{ item.content }}</div>
              </div>
            </li>
            <li v-if="item.flag == 1" class="item-content right-item">
              <div class="time">{{ item.create_time }}</div>
              <div class="item-content-right">
                <div class="item-message">{{ item.content }}</div>
                <img :src="item.head_img" alt="" />
              </div>
            </li>
          </ul>
          <!-- <div :class="(item.type == 1?'item-content right-item':'item-content left-item')">
        <div>{{ item.time }}</div>
        <div class="left-message">{{ item.message }}</div>
      </div> -->
          <!-- <div class="right-item">
        <div>{{ item.time }}</div>
        <div>{{ item.message }}</div>
      </div> -->
        </div>
      </div>
      <el-input type="textarea" :rows="4" :placeholder="pageTextArr[32]" v-model="transportquestionContent"
        maxlength="200" show-word-limit>
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="transportQuestionVisible = false">{{
          pageTextArr[34]
        }}</el-button>
        <el-button type="primary" @click="sendQuestion">{{
          pageTextArr[35]
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 选择收货地址 弹窗 -->
    <el-dialog :title="pageTextArr[36]" :visible.sync="changeAddressDialog" width="30%">
      <div class="change-ddress-dialog-modualr">
        <el-button class="add-address-btn" @click="addNewAddress()">{{
          pageTextArr[5]
        }}</el-button>
        <div class="receipt-item" v-for="(item, index) in receiptInfoList" :key="index"
          @click="selectAddressRadio(item.id, index, item.country_id)">
          <img v-if="addressDialogActiceAddressId == item.id" class="radio-icon" src="../assets/order/radio-icon-1.png"
            alt="" />
          <img v-else class="radio-icon" src="../assets/order/radio-icon-0.png" alt="" />
          <div class="receipt-name">{{ item.recivername }}</div>
          <div class="receipt-address">
            {{ item.province + item.city + item.area + item.address }}
          </div>
          <div class="receipt-mobile">{{ item.mobile }}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="changeAddressDialog = false">取 消</el-button> -->
        <el-button type="primary" @click="addressDioagConfirm()">{{
          pageTextArr[37]
        }}</el-button>
      </span>
    </el-dialog>
    <el-dialog title="新增收货地址" :visible.sync="showAddaddressDialog" :close-on-click-modal="false"
      :show-close="(showReceiptInfoList.length == 0 ? false : true)">
      <div class="dialog-add-address-modualr">
        <div class="dialog-add-address-body-modualr">
          <div class="dialog-add-address-info-item">
            <div class="dialog-add-address-info-header-title-item">
              <span class="red-icon">*</span>
              <span class="address-info-header-title">{{
                pageTextArr[43]
              }}</span>
            </div>
            <div class="dialog-add-address-info-input-item">
              <el-input autocomplete="new" v-model="addShippingAddressInfo.recivername"
                :placeholder=pageTextArr[43]></el-input>
            </div>
          </div>
          <div class="dialog-add-address-info-item">
            <div class="dialog-add-address-info-header-title-item">
              <span class="red-icon">*</span>
              <span class="address-info-header-title">{{
                pageTextArr[44]
              }}</span>
            </div>
            <div class="dialog-add-address-info-select-item">
              <el-row :gutter="20">
                <el-col :span="6" :xs="24">
                  <el-select autocomplete="new" v-model="currCountryId" filterable :placeholder=pageTextArr[52]
                    @change="selectCountryChange()">
                    <el-option v-for="item in countryData" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="6" :xs="24" v-show="showAddressItem">
                  <el-select autocomplete="new" v-model="currProvinceId" filterable :placeholder=pageTextArr[53]
                    @change="getCity()">
                    <el-option v-for="item in provinceData" :key="item.id" :label="item.name" :value="item.code"
                      @click="getCity">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="6" :xs="24" v-show="showAddressItem">
                  <el-select autocomplete="new" v-model="currCityid" filterable :placeholder=pageTextArr[54]
                    @change="getArea()">
                    <el-option v-for="item in cityData" :key="item.id" :label="item.name" :value="item.code">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="6" :xs="24" v-show="showAddressItem">
                  <el-select autocomplete="new" v-model="currAreaId" filterable :placeholder=pageTextArr[55]>
                    <el-option v-for="item in AreaData" :key="item.id" :label="item.name" :value="item.code">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="dialog-add-address-info-item">
            <div class="dialog-add-address-info-header-title-item">
              <span class="red-icon">*</span>
              <span class="address-info-header-title">{{
                pageTextArr[46]
              }}</span>
            </div>
            <div class="dialog-add-address-info-input-item">
              <el-input autocomplete="new" v-model="addShippingAddressInfo.address"
                :placeholder=pageTextArr[49]></el-input>
            </div>
          </div>
          <div class="dialog-add-address-info-item">
            <div class="dialog-add-address-info-header-title-item">
              <span class="red-icon">*</span>
              <span class="address-info-header-title">{{
                pageTextArr[46]
              }}</span>
            </div>
            <div class="dialog-add-address-info-input-item">
              <el-row :gutter="20">
                <el-col :span="8" :xs="24">
                  <el-select autocomplete="new" v-model="selectCompany" filterable
                    :placeholder="$t('translateText.placeholderText')">
                    <el-option v-for="item in countryData" :key="item.id" :label="item.name + item.area_code"
                      :value="item.area_code">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="16" :xs="24">
                  <el-input class="input-phone-item" v-model="addShippingAddressInfo.mobile"
                    :placeholder=pageTextArr[50]></el-input>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="dialog-add-address-info-item">
            <div class="dialog-add-address-info-header-title-item">
              <span class="red-icon">*</span>
              <span class="address-info-header-title">{{
                pageTextArr[47]
              }}</span>
            </div>
            <div class="dialog-add-address-info-input-item">
              <el-input v-model="addShippingAddressInfo.email" :placeholder=pageTextArr[51]></el-input>
            </div>
          </div>
        </div>
        <div class="dialog-add-address-footer-modualr">
          <el-button class="add-address-btn" @click="addAddress()">{{
            pageTextArr[37]
          }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      logo: "",
      order_key: "",
      showAddressItem:false,
      changeAddressDialog: false, //选择收货地址
      addressDialogActiceAddressId: 0, //弹窗-active的收货地址
      productDiscountPrice: 0, //订单金额
      coupon_id: "", //优惠券id
      discount_id: "", //
      country_id: "", //国家id
      full_package_id: "", //满邮id
      currLanguage: 1, //当前语言
      exchangeRateSymbol: "$", //当前货币符号
      showCouponMoney: false, //是否显示使用优惠券价格
      isShowCoupon: true, //显示-隐藏优惠券
      active: 0, //步骤条状态
      currAddressId: 0, //当前地址id
      showReceiptInfoList: [], //展示的收货地址
      selfPromotionList: {}, //展示的自提点
      receiptInfoList: [], //收货地址
      showIndex: 3,
      isDown: true,
      CurrpayModeType: 0, //当前中的支付方式
      payModeList: [], //支付方式=
      CurrtransportId: 0, //当前中的运输方式
      freight_price: 0, //运费
      tranportModeList: [], //运输方式
      tranportModeList1: [
        {
          imgUrl: "",
          name: "固定费用",
          id: 1,
        },
        {
          imgUrl: "",
          name: "自提",
          id: 2,
        },
        {
          imgUrl: "",
          name: "海运/空运",
          id: 3,
        },
      ],
      freight_type: 1,
      method_type: null,
      product_list: [], //商品Data
      confirmProductInformation: [], //订单-商品信息
      productTotalPrice: 0, //总价
      discount_price: 0, // （满减金额）
      coupon_price: 0, // （优惠券金额）
      tax_price: 0, // （税费金额）
      getExtraPriceStatus: false, //运输方式是否符合
      user_coupon_id: "", //个人优惠劵id

      couponList: [], //优惠券数据
      showCouponList: [], //展示的优惠券数据
      availablCouponList: {
        sum: "", //总计
        freight: "0.00", //运费
        taxation: "0.00", //税费
        couponMoney: "0.00", //优惠券
        address: "", //地址
        payMode: "", //付款方式
        full_discount_price: "0.00", //满减金额
      },
      // questionContent: "",
      // freightQuestionVisible: false,
      transportquestionContent: "",
      dialogName: "",
      transportQuestionVisible: false,
      chatList: [
        // {
        //   type: 1,
        //   message: "还有其他运输方式吗？",
        //   time: "2023-03-07 08:55:01",
        // },
        // {
        //   type: 2,
        //   message: "有",
        //   time: "2023-03-07 08:56:01",
        // },
        // {
        //   type: 2,
        //   message: "还有什么需要咨询的吗？",
        //   time: "2023-03-07 08:56:01",
        // },
        // {
        //   type: 1,
        //   message: "具体价格呢？",
        //   time: "2023-03-07 08:55:01",
        // },
        // {
        //   type: 2,
        //   message:
        //     "价格价格价格价格价格价格价格价格价格价格价格价格价格价格价格价格价格价格价格价格",
        //   time: "2023-03-07 08:56:01",
        // },
      ],
      pageTextArr: [
        "确认订单",
        "付款",
        "支付成功",
        "收货信息",
        "其他收货地址",
        "新增收货地址",
        "自提点",
        "付款方式",
        "运输方式",
        "点击此处咨询运费",
        "确认产品信息",
        "产品信息",
        "单价",
        "数量",
        "小计",
        "结算信息",
        "使用优惠券",
        "可用",
        "不可用",
        "商品数量",
        "税费",
        "运费",
        "优惠券",
        "满减金额",
        "应付金额",
        "付款方式",
        "提交订单",
        "消费满足",
        "减去",
        "全部商品",
        "有效期至",
        "总计",
        "咨询",
        "请输入咨询内容",
        "取消",
        "发送",
        "选择收货地址",
        "确认",
        "请先添加收货地址",
        "当前支付方式暂不支持",
        "当前运输方式不支持该产品",
        "更多地址",
        "收起地址",
        "收货人",
        "所在地区",
        "所在地址",
        "详细地址",
        "邮箱",
        "电话",
        "请输入详细地址",
        "请输入收货人电话",
        "请输入邮箱",
        "请选择国家",
        "请选择省",
        "请选择市",
        "请选择区",
      ],
      availablTabsList: [
        {
          title: "可用",
          eng_title: "available",
          num: 0,
        },
        {
          title: "不可用",
          eng_title: "unavailable",
          num: 0,
        },
      ],
      showAddaddressDialog: false,//添加收货地址
      countryData:[],
      currCountryId: "", //当前国家ID
      currCountryName: "", //当前国家名字
      provinceData: [], //省数据
      currProvinceId: "", //当前省ID
      cityData: [], //市数据
      currCityid: "", //当前市ID
      AreaData: [], //区数据
      selectCompany: "中国大陆 +86",
      currAreaId: "", //当前区ID
      addShippingAddressInfo: {
        recivername: "", //收货人姓名
        mobile: "", //手机号码
        country_id: "", //国家id
        email: "", //邮箱
        address: "", //详细地址1
        address2: "", //详细地址2
        is_default: 0, //默认地址-0：不是默认 1：默认地址
        provinceid: "", //省市区
        cityid: "", //市
        areaid: "", //区
      },
    };
  },
  methods: {
    /**
     * 首页
     */
    toHome() {
      this.$router.push({
        path: "/",
        // query: { name: '', age: '' }
      });
    },
    /**
     * 展示更多地址详情
     */
    showMoreAddress() {
      this.showIndex = this.receiptInfoList.length;
      this.isDown = false;
    },
    noshowMoreAddress() {
      this.showIndex = 3
      this.isDown = true;
    },
    /**
     * 收货地址列表
     */
    getAddressList() {
      let that = this;
      this.$http.addressList(
        null,
        (res) => {
          // 如果没有收货地址-显示新增收到地址的弹窗
          if (res.data.length == 0) {
            that.showAddaddressDialog = true;
            // 设置默认国家
            if (localStorage.getItem('curLanguage') == '简体中文') {
              that.currCountryId = '242';//中国
              that.showAddressItem = true;
            } else {
              that.currCountryId = '135';//美国
            }
          }
          that.showReceiptInfoList = res.data;
          that.receiptInfoList = res.data;
          res.data.forEach((v, i) => {
            if (v.default == 1) {
              // 地址信息
              that.availablCouponList.address =
                res.data[i].recivername +
                " " +
                res.data[i].mobile +
                " " +
                res.data[i].province +
                " " +
                res.data[i].city +
                " " +
                res.data[i].area +
                " " +
                res.data[i].address;
              // 当前地址id-默认
              that.currAddressId = res.data[0].id;
              // console.log("that.currAddressId",that.currAddressId);
              // that.addressDialogActiceAddressId = res.data[i].id;
              that.addressDialogActiceAddressId = that.currAddressId;
              // 国家id -default
              that.country_id = res.data[i].country_id;
            } else {
              // 地址信息
              that.availablCouponList.address =
                res.data[0].recivername +
                " " +
                res.data[0].mobile +
                " " +
                res.data[0].province +
                " " +
                res.data[0].city +
                " " +
                res.data[0].area +
                " " +
                res.data[0].address;
              // 当前地址id-默认
              that.currAddressId = res.data[0].id;
              that.addressDialogActiceAddressId = res.data[0].id;

              // 国家id -default
              that.country_id = res.data[0].country_id;
              that.getFreightList();
            }
          });
          // console.log(that.country_id, 697);
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 获取支付方式列表
     */
    getPaymentList() {
      let that = this;
      this.$http.getPaymentList(
        null,
        (res) => {
          that.payModeList = res.data;
          that.CurrpayModeType = res.data[0].type;
          that.availablCouponList.payMod = res.data[0].name;
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 获取运费方式列表
     */
    getFreightList() {
      let that = this;
      let data = {
        country_id: that.country_id,
        product_ids: that.product_list, //产品组
      };
      this.$http.getFreightList(
        data,
        (res) => {
          // let children = [
          //   {
          //     label: "固定费用",
          //     value: 1,
          //   },
          //   {
          //     label: "自提",
          //     value: 2,
          //   },
          //   {
          //     label: "海运/空运",
          //     value: 3,
          //   },
          // ];
          that.tranportModeList = res.data;
          that.tranportModeList;
          that.CurrtransportId = res.data[0].id;
          that.method_type = res.data[0].method_type
          // 获取运费税费
          that.getExtraPrice();
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 获取订单页面产品
     */
    getProductByOrder() {
      let that = this;
      let data = {
        exchange_rate: localStorage.getItem("currencyRate"),
        product_list: that.product_list,
      };
      this.$http.getOrderProductList(
        data,
        (res) => {
          if (res.ret == 1) {
            // 产品信息
            that.confirmProductInformation = res.data;
            if (
              that.confirmProductInformation[0].product_data.length > 0 &&
              this.currLanguage != 3 &&
              this.currLanguage != 1
            ) {
              that.languageTranslateByArrs(
                that.confirmProductInformation[0].product_data,
                3
              );
            }

            // （满邮活动id）
            that.full_package_id = res.full_package_id;
            // （满减折扣id）
            that.discount_id = res.full_discount_id;
            // 满减金额
            that.availablCouponList.full_discount_price =
              res.full_discount_price;
            // 价格计算
            that.calculationTotalPrice();
            // 优惠券列表
            that.couponList = res.couponData;
            //可用优惠券
            that.showCouponList = that.couponList.in_data;
            // 优惠券可用，不可用数量
            that.getCouponListNumByLength();
            // 优惠券添加数据
            that.setCouponListFlag();
            // 获取运费
            // setTimeout(() => {
            //   that.getFreightList();
            // }, 300);
            // 应付金额-满减金额
            that.availablCouponList.sum =
              that.availablCouponList.sum -
              that.availablCouponList.full_discount_price;
            that.availablCouponList.sum =
              Math.ceil(that.availablCouponList.sum * 100) / 100;
            that.order_key = res.order_key;
          } else {
            // this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 获取应付金额
     * @param {*} freight_price
     * @param {*} tax_price
     */
    getAmountPayable(freight_price, tax_price) {
      let that = this;
      // 运费
      that.freight_price = parseFloat(freight_price);
      // 税费
      that.tax_price = parseFloat(tax_price);
      // 应付金额-满减金额
      that.availablCouponList.sum =
        that.productTotalPrice -
        parseFloat(that.availablCouponList.full_discount_price) +
        parseFloat(freight_price) +
        parseFloat(tax_price);
      that.availablCouponList.sum =
        Math.ceil(that.availablCouponList.sum * 100) / 100;
    },

    /**
     * 优惠券可用，不可用数量
     */
    getCouponListNumByLength() {
      let that = this;
      if (that.couponList != "") {
        let inData = that.availablTabsList[0];
        let outData = that.availablTabsList[1];
        inData.num = that.couponList.in_data.length;
        outData.num = that.couponList.out_data.length;
        that.$set(that.availablTabsList, 0, inData);
        that.$set(that.availablTabsList, 1, outData);
        that.setTabsHeader();
      }
    },

    /**
     * 设置tabsheader
     */
    setTabsHeader() {
      let that = this;
      that.availablTabsList.forEach((v, i) => {
        v.title += " (" + v.num + ")";
      });
    },
    /**
     * 优惠券添加数据
     */
    setCouponListFlag() {
      let that = this;
      if (that.couponList != "") {
        that.showCouponList.forEach((v, i) => {
          v.flag = false;
        });
      }
    },

    /**
     * 选择优惠券-设置价格,更改总价
     * @param {*} index
     * @param {*} type
     */
    selectCoupon(index, type, discount, cash, status) {
      // 不可用 1-不可用
      if (status == 1) {
        return;
      }
      let that = this;
      let newData = that.showCouponList[index];
      if (!newData.flag) {
        that.showCouponList.forEach((v, i) => {
          v.flag = false;
        });
        that.coupon_id = newData.id; //优惠券id
        that.user_coupon_id = newData.user_coupon_id; //个人优惠劵id
      } else {
        that.coupon_id = ""; //优惠券id清空
        that.user_coupon_id = ""; //个人优惠劵id
      }
      newData.flag = !newData.flag;
      that.$set(that.showCouponList, index, newData);
      // 1折扣券2现金券
      // 总计
      if (type == 1) {
        if (newData.flag) {
          //优惠券显示
          that.showCouponMoney = true;
          // （优惠券金额）
          that.coupon_price = parseFloat(discount);
          // 减去满减金额  减去折扣
          that.availablCouponList.sum =
            that.productTotalPrice -
            that.availablCouponList.full_discount_price -
            that.productTotalPrice * (parseFloat(discount) / 100);

          // 加运费，加税费
          that.availablCouponList.sum += that.freight_price + that.tax_price;
          //  保留两位小数
          that.availablCouponList.sum =
            Math.ceil(that.availablCouponList.sum * 100) / 100;
          // 优惠金额
          that.availablCouponList.couponMoney =
            that.productTotalPrice * (parseFloat(discount) / 100);
          that.availablCouponList.couponMoney =
            Math.ceil(that.availablCouponList.couponMoney * 100) / 100;
        } else {
          that.showCouponMoney = false;
          that.coupon_price = 0;
          that.availablCouponList.couponMoney = "0.00";
          that.availablCouponList.sum =
            that.productTotalPrice -
            that.availablCouponList.full_discount_price;
          // 加运费，加税费
          that.availablCouponList.sum += that.freight_price + that.tax_price;
          // 保留两位小数
          that.availablCouponList.sum =
            Math.ceil(that.availablCouponList.sum * 100) / 100;
        }
      } else {
        // 优惠券金额
        if (newData.flag) {
          //优惠券显示
          that.showCouponMoney = true;
          // 减去满减金额  （满减金额）
          that.discount_price = parseFloat(cash);
          // 加上优惠
          that.availablCouponList.sum =
            that.productTotalPrice -
            that.availablCouponList.full_discount_price -
            parseFloat(cash);
          // 加运费，加税费
          that.availablCouponList.sum += that.freight_price + that.tax_price;
          that.availablCouponList.couponMoney = parseFloat(cash);
          // 保留两位小数
          that.availablCouponList.sum =
            Math.ceil(that.availablCouponList.sum * 100) / 100;
        } else {
          that.showCouponMoney = false;
          that.discount_price = 0;
          that.availablCouponList.couponMoney = "0.00";
          // 减去优惠
          that.availablCouponList.sum =
            that.availablCouponList.sum + parseFloat(cash);
          // 保留两位小数
          that.availablCouponList.sum =
            Math.ceil(that.availablCouponList.sum * 100) / 100;
        }
      }
    },

    /**
     * 计算总价，计算小计
     */
    calculationTotalPrice() {
      let that = this;
      that.confirmProductInformation.forEach((v, i) => {
        // 单个
        if (v.type == 1) {
          if (v.product_data[0].has_discount == 0) {
            // 没有优惠
            v.amountMoney =
              parseFloat(v.product_data[0].price) *
              parseFloat(v.product_data[0].num);
            // 结算金额
            that.productTotalPrice +=
              parseFloat(v.product_data[0].price) *
              parseFloat(v.product_data[0].num);
          } else {
            // 有优惠
            v.amountMoney =
              parseFloat(v.product_data[0].discount_price) *
              parseFloat(v.product_data[0].num);
            // 结算金额
            that.productTotalPrice +=
              parseFloat(v.product_data[0].discount_price) *
              parseFloat(v.product_data[0].num);
          }

          v.amountMoney = Math.ceil(v.amountMoney * 100) / 100;
        } else if (v.product_data[0].has_wholesale_price == 1) {
          // 批发价
          // 有优惠
          v.amountMoney =
            parseFloat(v.product_data[0].discount_price) *
            parseFloat(v.product_data[0].num);
          // 结算金额
          that.productTotalPrice +=
            parseFloat(v.product_data[0].discount_price) *
            parseFloat(v.product_data[0].num);
        } else {
          // 组合
          v.amountMoney =
            parseFloat(v.total_discount_price) *
            parseFloat(v.product_data[0].num);
          that.productTotalPrice +=
            parseFloat(v.total_discount_price) *
            parseFloat(v.product_data[0].num);
        }
      });
      // 总计
      that.productTotalPrice = Math.ceil(that.productTotalPrice * 100) / 100;
      // 应付金额 + 运费
      that.availablCouponList.sum =
        that.availablCouponList.sum +
        parseFloat(that.availablCouponList.freight);
      that.availablCouponList.sum =
        Math.ceil(that.productTotalPrice * 100) / 100;

      // 向上取证保留两位小数
      // that.selectProductPricrSum = Math.ceil(that.selectProductPricrSum * 100) / 100
    },

    /**
     * 选择收货信息
     * @param {*} id
     * @param {*} index
     * @param {*} country_id
     */
    selectRecipt(id, index, country_id) {
      let that = this;
      that.currAddressId = id;
      that.addressDialogActiceAddressId = that.currAddressId;
      that.country_id = country_id;
      that.availablCouponList.address =
        that.receiptInfoList[index].recivername +
        " " +
        that.receiptInfoList[index].mobile +
        " " +
        that.receiptInfoList[index].province +
        " " +
        that.receiptInfoList[index].city +
        " " +
        that.receiptInfoList[index].area +
        " " +
        that.receiptInfoList[index].address;
      // 获取运费税费
      that.getFreightList();
    },

    /**
     * 选择收货地址
     * @param {*} id
     * @param {*} index
     */
    selectAddressRadio(id, index) {
      let that = this;
      that.addressDialogActiceAddressId = id;
      // 循环选择的为true
      that.receiptInfoList.forEach((v, i) => {
        if (i == index) {
          v.checked = true;
        } else {
          v.checked = false;
        }
      });
      // console.log(' that.receiptInfoList', that.receiptInfoList);
    },

    /**
     * 选择收货地址确认
     */
    // addressDioagConfirm() {
    //   let that = this;
    //   that.receiptInfoList.forEach((v, i) => {
    //     if (v.checked == true) {
    //       that.currAddressId = v.id;
    //       that.country_id = v.country_id;
    //       that.availablCouponList.address =
    //         v.recivername +
    //         " " +
    //         v.mobile +
    //         " " +
    //         v.province +
    //         " " +
    //         v.city +
    //         " " +
    //         v.area +
    //         " " +
    //         v.address;
    //       that.showReceiptInfoList = [];
    //       that.showReceiptInfoList[0] = that.receiptInfoList[i];
    //     }
    //   });
    //   that.changeAddressDialog = false;
    //   // 获取运费税费
    //   that.getFreightList();
    //   if (that.method_type == 2) {
    //     this.method_type = 1;
    //   }
    // },

    /**
     * 支付方式
     * @param {*} index
     * @param {*} type
     */
    selectPay(index, type) {
      let that = this;
      that.CurrpayModeType = type;
      that.availablCouponList.payMod = that.payModeList[index].name;
    },
    /**
     * 运输方式咨询
     */
    transportTypeConsultation() {
      this.transportquestionContent = "";
      this.transportQuestionVisible = true;
      this.getList();
    },
    /**
     * 用户发送咨询
     */
    sendQuestion() {
      let data = {
        content: this.transportquestionContent,
      };
      if (this.transportquestionContent == "") {
        this.$message.warning(this.pageTextArr[33]);
      } else {
        this.$http.addData(data, (res) => {
          if (res.ret == 1) {
            this.transportquestionContent = "";
            this.$message.success(res.msg);
            this.getList();
          }
        });
      }
    },
    /**
     * 获取咨询运费列表信息
     */
    getList() {
      let data = {
        page: 1,
        pagesize: 1000,
      };
      this.$http.getList(data, (res) => {
        if (res.ret == 1) {
          this.chatList = res.data;
        }
      });
    },
    /**
     * 运输方式-选择
     * @param {*} id
     */
    selectTransport(id, method_type) {
      let that = this;

      this.CurrtransportId = id;
      this.method_type = method_type;
      // console.log("this.method_type", this.method_type);
      that.showReceiptInfoList.forEach((v, i) => {
        if (that.currAddressId == v.id) {
          that.availablCouponList.address =
            v.recivername + v.mobile + v.province + v.city + v.area + v.address;
        }
      });
      this.getExtraPrice();
    },
    /* 运输方式-选择
     * @param {*} id
     */
    // selectTransport1(id) {
    //   this.freight_type = id;
    //   console.log("freight_type", this.freight_type);
    //   this.getExtraPrice();
    // },

    /**
     * 优惠券-0-可用，1-不可用
     * @param {*} tab
     * @param {*} event
     */
    selectTabs(tab, event) {
      let that = this;
      if (event.srcElement.id.indexOf("0") > 1) {
        that.showCouponList = that.couponList.in_data; //可用优惠券
      } else {
        that.showCouponList = that.couponList.out_data; //不可用优惠券
      }
    },

    /**
     * 显示-隐藏优惠券
     */
    toggerShowCoupon() {
      this.isShowCoupon = !this.isShowCoupon;
    },

    /**
     * 添加收货地址
     */
    addNewAddress() {
      let that = this;
      that.showAddaddressDialog = true;

      // 清空
      that.addShippingAddressInfo = {};
      that.currCountryId = "";
      that.currProvinceId = "";
      that.currCityid = "";
      that.currAreaId = "";
      // 设置默认国家
      if (localStorage.getItem('curLanguage') == '简体中文') {
        that.currCountryId = '242';//中国
        that.showAddressItem = true;
      } else {
        that.currCountryId = '135';//美国
      }

      // this.$router.push({
      //   path: "/personalCenter",
      //   query: {
      //     pageStatus: 1,
      //     index: 4,
      //   },
      // });
    },
    /**
 * 国家选择
 */
    selectCountryChange() {
      let that = this;
      console.log("currCountryId", that.currCountryId);
      if (that.currCountryId == 242) {
        // 中国
        that.showAddressItem = true;
      } else {
        that.showAddressItem = false;
        // 省
        that.addShippingAddressInfo.provinceid = "";
        // 市
        that.addShippingAddressInfo.cityid = "";
        // 区
        that.addShippingAddressInfo.areaid = "";
      }
    },

    /**
     * 获取国家列表
     */
    getCountry() {
      let that = this;
      this.$http.getCountry(
        null,
        (res) => {
          that.countryData = res.data;
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 获取省列表
     */
    getProvince() {
      let that = this;
      this.$http.getProvince(
        null,
        (res) => {
          that.provinceData = res.data;
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 获取市列表
     */
    getCity() {
      let that = this;
      // 清空
      that.cityData = [];
      that.currCityid = "";
      that.AreaData = [];
      that.currAreaId = "";
      let data = {
        code: that.currProvinceId,
      };
      this.$http.getCity(
        data,
        (res) => {
          that.cityData = res.data;
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 获取区列表
     */
    getArea() {
      let that = this;
      // 清空
      that.AreaData = [];
      that.currAreaId = "";
      let data = {
        code: that.currCityid,
      };
      this.$http.getArea(
        data,
        (res) => {
          that.AreaData = res.data;
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 运费咨询
     */
    freightConsultation() {
      this.freightQuestionVisible = true;
    },

    /**
     * 提交订单
     */
    submitOrder() {
      let that = this;
      // 判断是否有有收货地址
      if (that.currAddressId == "" || that.country_id == "") {
        // this.$message.error((that.currLanguage==3?"Please add the shipping address first":"请先添加收货地址"));

        let loadingText =
          that.currLanguage == 3
            ? "Please add the shipping address first"
            : this.pageTextArr[38];
        const loading = this.$loading({
          lock: true,
          text: loadingText,
          spinner: "el-icon-data-line",
          customClass: "loadingclass",
          background: "rgba(0, 0, 0, 0.7)",
        });
        setTimeout(() => {
          loading.close();
          this.$router.push({
            path: "/personalCenter",
            query: {
              pageStatus: 1,
              index: 4,
            },
          });
        }, 2000);
      }
       else if (that.CurrpayModeType == 1 && localStorage.getItem("currencySymbol")!='￥') {
        this.$message.warning(
          that.currLanguage == 3
            ? "Please switch to RMB（CNY） in the upper left corner"
            : '请在左上角切换到人民币（CNY）'
        );
      } 
      else {
        // 清除
        localStorage.removeItem("localStorageProductData");
        // 下单
        this.productOrder();
      }
    },

    /**
     * 切换国家，运输方式 订单获取运费税费
     */
    getExtraPrice() {
      let that = this;
      // let status = false;
      let data = {
        country_id: that.country_id, //国家ID
        freight_id: that.CurrtransportId, //运输方式id
        freight_type: that.freight_type,
        full_pack_age_id: that.full_package_id, //（满邮活动id）
        product_ids: that.product_list, //产品组
        product_total_price: that.productTotalPrice, //产品总价
        exchange_rate: localStorage.getItem("currencyRate"),
        exchange_rate_symbol: localStorage.getItem("currencySymbol"),
        method_type: that.method_type,
        order_key: that.order_key,
      };
      this.$http.getExtraPrices(
        data,
        (res) => {
          if (res.ret == 1) {
            that.freight_price = res.data.freight_price;
            that.tax_price = res.data.taxation;
            // 运费
            that.availablCouponList.freight = res.data.freight_price;
            // 说费
            that.availablCouponList.taxation = res.data.tax_price;
            that.getExtraPriceStatus = true;
            // 计算应付金额
            that.getAmountPayable(
              that.availablCouponList.freight,
              that.availablCouponList.taxation
            );
            if (that.method_type == 2) {
              that.availablCouponList.address =
                res.contact_name + res.contact_mobile + res.address;
              that.selfPromotionList = res;
            }
          } else {
            that.availablCouponList.freight = "0.00";
            that.availablCouponList.taxation = "0.00";
            that.getExtraPriceStatus = false;
            // this.$message.error(res.msg);
            // 计算应付金额
            that.getAmountPayable(
              that.availablCouponList.freight,
              that.availablCouponList.taxation
            );
          }
        },
        (res) => {
          that.availablCouponList.freight = "0.00";
          that.availablCouponList.taxation = "0.00";
          that.getExtraPriceStatus = false;
          // this.$message.error(res.msg);
          // 计算应付金额
          that.getAmountPayable(
            that.availablCouponList.freight,
            that.availablCouponList.taxation
          );
        }
      );

      // console.log('status',status);
      // return status;
    },

    /**
     * 下单
     */
    productOrder() {
      let that = this;
      if (!that.getExtraPriceStatus) {
        this.$message.error(
          that.currLanguage == 3
            ? "The product is not supported by the current transportation method"
            : this.pageTextArr[40]
        );
        return;
      }
      let data = {
        product_list: that.product_list,
        address_id: that.currAddressId, //地址id
        payment_id: that.CurrpayModeType, //（支付方式id）
        freight_id: that.CurrtransportId, //（运费id）
        freight_price: that.freight_price, //（运费）
        full_pack_age_id: that.full_package_id, //（满邮活动id）
        discount_id: that.discount_id, //（满减折扣id）
        user_coupon_id: that.user_coupon_id, //个人优惠劵id
        coupon_id: that.coupon_id, //（优惠券id）
        product_total_price: that.productTotalPrice, //（商品总价）
        exchange_rate: localStorage.getItem("currencyRate"),
        exchange_rate_id: localStorage.getItem("exchangeRateId"), //(汇率id)
        exchange_rate_symbol: localStorage.getItem("currencySymbol"), //(汇率符号)
        end_price: that.availablCouponList.sum, //  （合计金额）
        tax_price: that.tax_price, // （税费金额）
        discount_price: that.availablCouponList.full_discount_price, // （满减金额）
        coupon_price: that.availablCouponList.couponMoney, //（优惠券金额）
        order_key: that.order_key,
      };
      this.$http.productOrders(
        data,
        (res) => {
          if (res.ret == 1) {
            this.$router.push({
              path: "/waitingPayment",
              query: {
                order_id: res.order_id,
                order_number: res.order_number,
                page_status: 1,
              },
            });
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          this.$message.error(res.msg);
        }
      );
    },
    /**
     * 跳转商品详情
     * @param {*} id
     */
    toProductDetail(id) {
      this.$router.push({
        path: "/productDetail",
        query: { product_id: id },
      });
    },

    /**
     * 订单,购物车选中数据是否满足满减
     */
    // getDataDiscount() {
    //   let that = this;
    //   let data = {
    //     price: that.productDiscountPrice,
    //     exchange_rate: localStorage.getItem('currencyRate'),//汇率值
    //     exchange_rate_symbol: localStorage.getItem('currencySymbol')
    //   }
    //   this.$http.getDataDiscount(
    //     data,
    //     (res) => {
    //       if (res.ret == 1) {
    //         // （满邮活动id）
    //         that.full_package_id = res.full_package_id;
    //         // （满减折扣id）
    //         that.discount_id = res.discount_id;
    //         // 满减金额
    //         that.availablCouponList.full_discount_price = res.full_discount_price;

    //       } else {
    //         this.$message.error(res.msg);
    //       }
    //     },
    //     (res) => {
    //       // this.$message.error(res.msg);

    //     }
    //   )
    // },

    /**
     * 支付
     */
    orderPay() {
      let that = this;
      let data = {
        order_number: "", //订单编号
        money: "", //支付金额
        currency: localStorage.getItem("currencyName"), // USD 默认美元
        exchange_rate: localStorage.getItem("currencyRate"),
      };
      this.$http.orderPay(
        data,
        (res) => {
          if (res.ret == 1) {
          } else {
            // this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 检测url参数
     */
    checkUrlParameter() {
      let payer_id = that.$route.query.payer_id;
      let token = that.$route.query.token;
    },

    /**
     * 成功支付查询
     */
    successPay(payer_id) {
      let that = this;
      let data = {
        order_id: "", //订单id
        order_number: "", //编号
        payment_id: "",
        payer_id: payer_id,
      };
      this.$http.successPay(
        data,
        (res) => {
          if (res.ret == 1) {
            // 跳转支付成功页面
            this.$router.push({
              path: "/orderPaymentSucceeded",
              // query: {
              //   pageStatus: 1,
              //   index: 4,
              // }
            });
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 取消支付查询
     */
    cancelPay(token) {
      let that = this;
      let data = {
        order_id: "", //订单id
        order_number: "", //编号
        token: token,
        payment_id: "",
        currency: localStorage.getItem("currencyName"), // USD 默认美元
      };
      this.$http.cancelPay(
        data,
        (res) => {
          if (res.ret == 1) {
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },
    translateByArr(arr, callback, errCallBack) {
      let that = this;
      let data = {
        text: arr, //带翻译数组
        from: localStorage.getItem("oldLanguageCode"), //源语言
        to: localStorage.getItem("curLanguageCode"), //目标语言
      };
      if (data.from == data.to) {
        return;
      }
      this.$http.translateByArr(data, callback, errCallBack);
    },

    languageTranslateByArrs(arr, type) {
      let that = this;
      let newpagetextArr = [];
      if (type == 1) {
        that.translateByArr(arr, (res) => {
          console.log("res", res);
          res.data.forEach((item, index) => {
            newpagetextArr.push(item.translation);
          });
          that.pageTextArr = newpagetextArr;
        });
      } else if (type == 2) {
        let newArr = [];
        arr.forEach((item, index) => {
          newArr.push(item.title);
        });
        that.translateByArr(newArr, (res) => {
          res.data.forEach((items, indexs) => {
            that.availablTabsList[indexs].title = items.translation;
          });
        });
      } else {
        let newarr = [];
        let skuarr = [];
        arr.forEach((item, index) => {
          newarr.push(item.title);
          skuarr.push(item.specifications);
        });
        that.translateByArr(newarr, (res) => {
          res.data.forEach((item, index) => {
            that.confirmProductInformation[0].product_data[index].title =
              item.translation;
          });
        });
        that.translateByArr(skuarr, (res) => {
          res.data.forEach((item, index) => {
            that.confirmProductInformation[0].product_data[
              index
            ].specifications = item.translation;
          });
        });
      }
    },
    /**
     * 获取网站logo以及名称
     */
    getSystemConfig() {
      this.$http.getSystemConfig({}, (res) => {
        if (res.ret == 1) {
          this.logo = res.data.sys_site_logo;
        }
      });
    },

    /**
     * 新增收货地址
     */
    addAddress() {
      let that = this;
      // 国家
      that.addShippingAddressInfo.country_id = that.currCountryId;
      // 省
      that.addShippingAddressInfo.provinceid = that.currProvinceId;
      // 市
      that.addShippingAddressInfo.cityid = that.currCityid;
      // 区
      that.addShippingAddressInfo.areaid = that.currAreaId;
      that.addShippingAddressInfo.is_default = 0;
      that.addShippingAddressInfo.address2 = "";
      let data = that.addShippingAddressInfo;
      this.$http.addAddress(
        data,
        (res) => {
          if (res.ret == 1) {
            this.$message.success(res.msg);
            // 收货地址
            that.getAddressList();
            that.showAddaddressDialog = false;
            // that.getFreightList()
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          this.$message.error(res.msg);
        }
      );
    }

  },
  mounted() {
    let that = this;
    // 上个页面传参-
    that.product_list = JSON.parse(
      localStorage.getItem("localStorageProductData")
    ).productData; //that.$route.query.data;
    // 订单金额
    that.productDiscountPrice = JSON.parse(
      localStorage.getItem("localStorageProductData")
    ).productPrice; //that.$route.query.productPrice;

    // 当前语言
    that.currLanguage = localStorage.getItem("curLanguageType");
    // 当前货币符号
    that.exchangeRateSymbol = localStorage.getItem("currencySymbol");

    // 是否满减
    // that.getDataDiscount();
    // 收货地址
    that.getAddressList();
    // 获取支付方式列表
    that.getPaymentList();
    // 获取运费方式列表
    // that.getFreightList();
    // 获取订单页面产品
    that.getProductByOrder();
    // 检测url参数
    // that.checkUrlParameter();
    that.languageTranslateByArrs(that.pageTextArr, 1);
    that.languageTranslateByArrs(that.availablTabsList, 2);
    this.getSystemConfig();
    // 获取国家列表
    that.getCountry();
    // 获取省列表
    that.getProvince();
  },
  destroyed() {
    // 离开页面清除
    // localStorage.removeItem('localStorageProductData');
  },
};
</script>


// WEBPACK FOOTER //
// src/view/confirmOrder.vue